<!--
 * @Description: 交付,签合同等公共formItem
 * @Author: black-k
 * @Date: 2025-09-09 17:03:23
 * @LastEditors: black-k
 * @LastEditTime: 2025-10-31 17:21:46
-->
<template>
    <el-form :model="ruleForm" :rules="composRules" ref="ruleFormRef" label-width="100px" class="action-form">
        <!-- 自定义插槽 -->
        <slot name="custom" :form="ruleForm"></slot>

        <!-- 描述 -->
        <el-form-item :label="desc.label" prop="description">
            <el-input
                type="textarea"
                v-model="ruleForm.description"
                :placeholder="desc.placeholder"
                resize="none"
                :rows="7"
                show-word-limit
                maxlength="500"
            ></el-input>
        </el-form-item>

        <!-- 添加链接 -->
        <el-form-item label="添加链接">
            <div class="url-item" v-for="(url, index) in ruleForm.urls" :key="url.key">
                <el-form-item :prop="`urls[${index}].name`" :rules="rules.url_name">
                    <el-input v-model="ruleForm.urls[index].name" placeholder="请输入链接名称"></el-input>
                </el-form-item>

                <el-form-item :prop="`urls[${index}].url`" :rules="rules.url_path">
                    <el-input v-model="ruleForm.urls[index].url" placeholder="请输入链接地址"></el-input>
                </el-form-item>

                <i class="el-icon-delete" @click="handleDeleteLink(url.key)"></i>
            </div>

            <el-button type="text" @click="handleAddLink">添加链接</el-button>
        </el-form-item>

        <!-- 上传附件 -->
        <el-form-item label="上传附件">
            <template v-for="(file, index) in ruleForm.files">
                <div class="file-item" :key="index">
                    <div class="file-item_top flex-center">
                        <div class="top-name ellipsis-single">{{ file.file_name }}</div>

                        <i class="el-icon-download" v-if="file.file_url" @click="handleDown(file)"></i>
                    </div>

                    <!-- 上传中，且没有文件url -->
                    <div class="file-item_bottom flex-center" v-if="uploadFlag.isUpload && !file.file_url">
                        <div class="bottom-progress">
                            <div class="progress-bar" :style="{ width: `${uploadFlag.progress}%` }"></div>
                        </div>

                        <div class="progress-text">{{ uploadFlag.progress.toFixed(1) }}%</div>
                    </div>

                    <!-- 删除资源 -->
                    <el-popover ref="deleteSourceRef" placement="top" width="208" trigger="click" v-if="file.file_url">
                        <i class="el-icon-circle-close" slot="reference"></i>

                        <div class="delete-source-poppver">
                            <div class="poppver-tip">确定删除该资源？</div>

                            <div class="poppver-btn flex-center">
                                <div class="btn-item" @click="handleCancelSource(index)">取消</div>
                                <div class="btn-item primary" @click="handleDeleteFile(index)">确定</div>
                            </div>
                        </div>
                    </el-popover>
                </div>
            </template>

            <UploadFileWidget
                ref="uploadFileRef"
                :accept="fileTypes.join(',')"
                :limit-size="1024 * 1024 * 200"
                :beforeUpload="beforeUpload"
                @vaidalteError="handleUploadValidateError"
                @progress="handleUploadProgress"
                @success="handleUploadSuccess"
                @error="handleUploadError"
            >
                <el-button type="text" slot="target">上传附件</el-button>
            </UploadFileWidget>
        </el-form-item>
    </el-form>
</template>

<script>
import { v4 } from "uuid";
import UploadFileWidget from "@/utils/upload/UploadFileWidget.vue";
import { downloadFile } from "@/utils/common";

export default {
    data() {
        let urlValidate = (rule, value, callback) => {
            let reg = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;

            if (!reg.test(value)) {
                return callback(new Error("请输入正确格式的链接地址"));
            }

            callback();
        };

        return {
            fileTypes: [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".zip", ".7z", ".mp4"],
            ruleForm: {
                description: "",
                urls: [],
                files: [],
            },
            rules: {
                description: [],
                url_name: [
                    { required: true, message: "请输入链接名称", trigger: "blur" },
                    { min: 1, max: 20, message: "链接名称限制1-20字", trigger: "blur" },
                ],
                url_path: [
                    { required: true, message: "请输入链接地址", trigger: "blur" },
                    { validator: urlValidate, trigger: "blur" },
                ],
            },
            uploadFlag: {
                isUpload: false,
                progress: 0,
            },
        };
    },

    props: {
        desc: {
            type: Object,
            default: () => ({
                label: "",
                placeholder: "",
            }),
        },

        required: {
            type: Boolean,
            default: true,
        },

        otherRules: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        composRules() {
            return { ...this.rules, ...this.otherRules };
        },
    },

    components: {
        UploadFileWidget,
    },

    methods: {
        initData(val) {
            this.ruleForm = { ...val };
        },

        reset() {
            if (this.uploadFlag.isUpload) {
                this.$refs.uploadFileRef?.cancelUpload2Oss?.();
            }

            this.ruleForm = {
                description: "",
                urls: [],
                files: [],
            };

            this.uploadFlag = {
                isUpload: false,
                progress: 0,
            };
        },

        handleDown(file) {
            downloadFile(file.file_url, file.file_name);
        },

        // 添加链接
        handleAddLink() {
            this.ruleForm.urls.push({
                key: v4().replaceAll("-", ""),
                name: "",
                url: "",
            });
        },

        handleDeleteLink(key) {
            const deleteIndex = this.ruleForm.urls.findIndex((item) => item.key === key);

            if (deleteIndex !== -1) {
                this.ruleForm.urls.splice(deleteIndex, 1);
            }
        },

        // 上传前校验
        beforeUpload(file) {
            if (this.uploadFlag.isUpload) {
                this.$message.warning("文件正在上传");
                return false;
            }

            // this.uploadFlag.isUpload = true;
            this.uploadFlag.progress = 0;

            this.ruleForm.files.push({
                file_name: file.name,
                file_url: "",
            });
        },

        // 上传校验文件失败
        handleUploadValidateError() {
            this.ruleForm.files.pop();
        },

        // 上传进度条
        handleUploadProgress(percent) {
            this.uploadFlag.isUpload = true;
            this.uploadFlag.progress = Math.min(99, percent * 100);
        },

        // 上传成功
        handleUploadSuccess(val) {
            const files = this.ruleForm.files;

            if (files.length > 0) {
                this.$set(this.ruleForm.files[files.length - 1], "file_url", val.path);
                this.uploadFlag.isUpload = false;
            }
        },

        // 上传失败
        handleUploadError() {
            this.ruleForm.files.pop();
            this.uploadFlag.isUpload = false;
        },

        // 取消删除
        handleCancelSource(index) {
            this.$refs.deleteSourceRef?.[index]?.doClose?.();
        },

        // 删除文件
        handleDeleteFile(index) {
            this.ruleForm.files.splice(index, 1);
        },

        // 校验
        validate(callback) {
            const _this = this;
            this.$refs.ruleFormRef?.validate((valid) => {
                if (valid) {
                    if (this.uploadFlag.isUpload) {
                        this.$message.warning("文件正在上传");
                        return;
                    }

                    if (_this.ruleForm.urls.length === 0 && _this.ruleForm.files.length === 0) {
                        this.$message.warning("请添加链接或上传文件");
                        return;
                    }

                    callback(valid, _this.ruleForm);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.action-form {
    ::v-deep .el-form-item {
        display: flex;
        // align-items: center;

        .el-form-item__label {
            width: 70px !important;
            font-weight: 500;
            font-size: 14px;
            color: #262626;
            text-wrap: nowrap;
        }

        .el-form-item__content {
            margin-left: 0 !important;
            flex: 1;
        }

        &.is-required {
            .el-form-item__label::before {
                display: none;
            }
        }

        .el-textarea .el-input__count {
            background: transparent !important;
        }
    }

    .el-button--text {
        color: #594fed;
        padding-block: 0;
    }

    .url-item {
        display: flex;
        align-items: center;
        gap: 10px;

        & + .url-item {
            margin-top: 16px;
        }

        .el-icon-delete {
            cursor: pointer;
            font-size: 16px;
            color: #ff0000;
        }

        .el-form-item {
            flex: 1;

            ::v-deep .el-form-item__error {
                font-size: 11px;
            }
        }

        &:last-of-type {
            margin-bottom: 4px;
        }
    }

    ::v-deep .upload-container {
        height: fit-content;

        .upload-progress {
            display: none;
        }
    }

    .file-item {
        width: 360px;
        padding: 10px 12px;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        background: #f4f4f4;
        border-radius: 4px;
        position: relative;

        & + .file-item {
            margin-top: 12px;
        }

        &_top,
        &_bottom {
            width: 100%;
            justify-content: space-between;
            line-height: 1;
        }

        &_top {
            .top-name {
                width: 80%;
            }

            .el-icon-download {
                font-size: 16px;
                color: #291ce7;
                cursor: pointer;
            }
        }

        &_bottom {
            margin-top: 8px;

            .bottom-progress {
                width: 142px;
                height: 6px;
                background: #d9d9d9;
                border-radius: 4px;
                overflow: hidden;

                .progress-bar {
                    height: 100%;
                    background-color: #594fed;
                    border-radius: 4px;
                }
            }

            .progress-text {
                font-weight: 400;
                font-size: 12px;
                color: #999999;
            }
        }

        .el-icon-circle-close {
            position: absolute;
            color: #ff0000;
            top: 0;
            right: 0;
            cursor: pointer;
            font-size: 16px;
            transform: translate(50%, -50%);
            display: none;
        }

        &:hover {
            .el-icon-circle-close {
                display: block;
            }
        }
    }
}
</style>

<style lang="scss">
.delete-source-poppver {
    .poppver-tip {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-bottom: 16px;
    }

    .poppver-btn {
        justify-content: flex-end;
        gap: 10px;

        .btn-item {
            padding: 4px 10px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            font-weight: 400;
            font-size: 12px;
            color: #646669;
            cursor: pointer;

            &.primary {
                background-color: #594fed;
                border: 1px solid #594fed;
                color: #ffffff;
            }
        }
    }
}
</style>
